export const BASKET_QUERY = `query basket($currency: Currency) {
  basket(currency: $currency) {
    items {
      product {
        code
      }
    }
  }
}`;
